export const HOME_PATH = '/';
export const HOME_URL = 'http://localhost:3000';
export const CONTENT_ROOT_PATH = HOME_PATH + 'seite/';
export const CONTENT_PATH = CONTENT_ROOT_PATH + ':page';
export const IMPRESSUM_PATH = '/impressum';
export const DATA_URL = 'https://www.personalized-medicine.at/datenschutzerklaerung/';
